module.exports = "/static/assets/b90a17057bbf66504884041c3f09bc53.png";